export default __webpack_public_path__ + "static/media/right_arrow_icon.e215ce8c.svg";